<template>
  <div class="registerBox">
    <el-header height="46px">
      <span class="text" @click="loginTo">返回</span>
    </el-header>
    <div class="body">
      <div class="body-text">
        <span v-if="businessFlg == '1'">业务类型：托运业务</span>
        <span v-if="businessFlg == '2'">业务类型：承运业务</span>
        <span v-if="businessFlg == '3'">业务类型：车队长业务</span>
      </div>

        <el-form
          :model="tuoYunFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          ref="tuoYunFrom"
          class="demo-form-inline"
          label-width="180px" size="small">
          <div class="fromBox">
          <el-form-item label="企业名称：" prop="companyName" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入企业名称" maxlength="" :disabled="true" v-model.trim="tuoYunFrom.companyName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="营业执照号：" prop="bsnsLicenseno" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入营业执照号" @blur="getcontractNameOrTel" :disabled="true" maxlength="" v-model.trim="tuoYunFrom.bsnsLicenseno" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="道路运输经营许可证号：" prop="transPermitno" v-if="businessFlg == '2'">
            <el-input  placeholder="请输入道路运输经营许可证号" maxlength="" v-model.trim="tuoYunFrom.transPermitno" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名：" prop="legalPerson" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入法人姓名" maxlength="" v-model.trim="tuoYunFrom.legalPerson" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="车队长姓名：" prop="legalPerson" v-if="businessFlg == '3'">
            <el-input  placeholder="请输入车队长姓名" maxlength="" v-model.trim="tuoYunFrom.legalPerson" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="身份证号：" prop="legalPersonId">
            <el-input  placeholder="请输入法人身份证号" maxlength="18" v-model.trim="tuoYunFrom.legalPersonId" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证有效期：" prop="personidValidity" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入法人身份证有效期（格式2020-08-27）"  maxlength="" v-model.trim="tuoYunFrom.personidValidity" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contractName">
            <el-input  placeholder="请输入联系人" maxlength="" :disabled="contractNameDisabled" v-model.trim="tuoYunFrom.contractName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="contractPhone">
            <el-input  placeholder="请输入联系电话" maxlength="11" :disabled="contractNameDisabled" v-model.trim="tuoYunFrom.contractPhone" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="是否持有驾驶证" prop="bsnsOneness" v-if="businessFlg == '3'">
            <el-radio-group v-model="tuoYunFrom.bsnsOneness"   @change="radioChangeJSZ">
              <el-radio  label="0">是</el-radio>
              <el-radio  label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item label="驾驶证号" prop="transPermitno" v-if="businessFlg == '3'&&tuoYunFrom.bsnsOneness=='0'">
            <el-input  placeholder="请输入驾驶证号" maxlength="18" v-model.trim="tuoYunFrom.transPermitno " style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="是否三证合一：" prop="bsnsOneness" v-if="businessFlg != '3'">
            <el-radio-group v-model="tuoYunFrom.bsnsOneness" @change="radioChange">
              <el-radio  label="0">是</el-radio>
              <el-radio  label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          </div>
          <!-- 三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.bsnsOneness == '0'&& businessFlg == '1'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox">
                <uploadImg :img='img' key="0" @remove ='handleRemove'  @change ='imgPreview' ></uploadImg>
                <span>营业执照</span>
              </div>
               <div class="imgBox">
                <uploadImg :img='img1' key="1" @remove ='handleRemove1'  @change ='imgPreview1'></uploadImg>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='img2' key="2" @remove ='handleRemove2'  @change ='imgPreview2'></uploadImg>
                <span>身份证反面</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 非三证合一 -->
          <div class="uploadBox" v-else-if="tuoYunFrom.bsnsOneness == '1'&& businessFlg == '1'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox">
                <uploadImg :img='Fimg' key="3" @remove ='handleRemoveF'  @change ='imgPreviewF'></uploadImg>
                <span>营业执照</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='Fimg1' key="4" @remove ='handleRemoveF1'  @change ='imgPreviewF1'></uploadImg>
                <span>税务登记证</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='Fimg2' key="5" @remove ='handleRemoveF2'  @change ='imgPreviewF2'></uploadImg>
                <span>组织机构代码</span>
              </div>
               <div class="imgBox">
                <uploadImg :img='Fimg3' key="6" @remove ='handleRemoveF3'  @change ='imgPreviewF3'></uploadImg>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='Fimg4' key="7" @remove ='handleRemoveF4'  @change ='imgPreviewF4'></uploadImg>
                <span>身份证反面</span>
              </div>
              <div class="imgBox">
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 承运三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.bsnsOneness == '0' && businessFlg == '2' && isflg">
          <el-form-item label="证件上传：">
            <div class="box">
              <div class="imgBox" >
                <uploadImg :img='cYimg' key="0" @remove ='handleRemovecY'  @change ='imgPreviewcY'></uploadImg>
                <span>营业执照</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='cYimg1' key="1" @remove ='handleRemovecY1'  @change ='imgPreviewcY1'></uploadImg>
                <span>道路运输经营许可证号</span>
              </div>
               <div class="imgBox">
                <uploadImg :img='cYimg2' key="2" @remove ='handleRemovecY2'  @change ='imgPreviewcY2'></uploadImg>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='cYimg3' key="3" @remove ='handleRemovecY3'  @change ='imgPreviewcY3'></uploadImg>
                <span>身份证反面</span>
              </div>
              <div class="imgBox">
              </div>
              <div class="imgBox">
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 承运非三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.bsnsOneness == '1' && businessFlg == '2'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox" >
                <uploadImg :img='FcYimg' key="4" @remove ='handleRemovecYF'  @change ='imgPreviewcYF'></uploadImg>
                <span >营业执照</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='FcYimg1' key="5" @remove ='handleRemovecYF1'  @change ='imgPreviewcYF1'></uploadImg>
                <span>税务登记证</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='FcYimg2' key="6" @remove ='handleRemovecYF2'  @change ='imgPreviewcYF2'></uploadImg>
                <span>道路运输经营许可证号</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='FcYimg3' key="7" @remove ='handleRemovecYF3'  @change ='imgPreviewcYF3'></uploadImg>
                <span>组织机构代码</span>
              </div>
               <div class="imgBox">
                 <uploadImg :img='FcYimg4' key="8" @remove ='handleRemovecYF4'  @change ='imgPreviewcYF4'></uploadImg>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <uploadImg :img='FcYimg5' key="9" @remove ='handleRemovecYF5'  @change ='imgPreviewcYF5'></uploadImg>
                <span>身份证反面</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 车队长证件 -->
          <div class="uploadBox" v-if="businessFlg == '3'">
          <el-form-item label="证件上传：" >
            <div class="box" style="width:650px;justify-content: initial;">
               <div class="imgBox"  style="margin-right: 7px;">
                <uploadImg :img='cheDui1' key="1" @remove ='cheDuiRemove1'  @change ='cheDuiPreview1'></uploadImg>
                <span>身份证正面</span>
              </div>
              <div class="imgBox"  style="margin-right: 7px;">
                <uploadImg :img='cheDui2' key="2" @remove ='cheDuiRemove2'  @change ='cheDuiPreview2'></uploadImg>
                <span>身份证反面</span>
              </div>
               <div class="imgBox"  style="margin-right: 7px;" v-if="tuoYunFrom.bsnsOneness=='0'">
                <uploadImg :img='cheDui3' key="1" @remove ='cheDuiRemove3'  @change ='cheDuiPreview3'></uploadImg>
                <span>驾驶证正页</span>
              </div>
              <div class="imgBox" v-if="tuoYunFrom.bsnsOneness=='0'">
                <uploadImg :img='cheDui4' key="2" @remove ='cheDuiRemove4'  @change ='cheDuiPreview4'></uploadImg>
                <span>驾驶证副页</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <div class="submitBtn">
            <el-button type="primary" style="width:100%;height:40px;" size="amall" :loading="submitLoading" @click="submitClick('tuoYunFrom')">提交审核</el-button>
          </div>
        </el-form>
    </div>
  </div>
</template>
<script>
// import { encryption } from '@/utils/util'
// import InputGroup from '@/components/inputGroup.vue' // 引入封装的组件
// import store from '@/store'
import uploadImg from '@/components/uploadImg.vue'
import { registerInfoUpdate } from '@/api/consignment'
import { compressImage } from '@/utils/compressImage'
export default {
  components: {
    uploadImg
  },
  data () {
    return {
      registerInfo: {},
      businessFlg: '',
      // 托运
      tuoYunFrom: {
        companyName: '', // 企业名称
        bsnsLicenseno: '', // 营业执照号
        legalPerson: '', // 法人姓名
        legalPersonId: '', // 法人身份证
        personidValidity: '', // 法人身份证有效期
        contractName: '', // 联系人
        contractPhone: '', // 联系电话
        bsnsOneness: '0', // 托运三证合一
        transPermitno: '' // 道路运输许可证号
      },
      contractNameDisabled: false,
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        bsnsLicenseno: [
          { required: true, message: '请输入营业执照号', trigger: 'blur' }
        ],
        transPermitno: [
          { required: true, message: '请输入道路运输经营许可证号', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legalPersonId: [
          { required: true, message: '请输入法人身份证', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        personidValidity: [
          { required: true, message: '请输入法人身份证有效期', trigger: 'blur' }
        ],
        contractName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contractPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        bsnsOneness: [
          { required: true, message: '请选择托运三证合一', trigger: 'blur' }
        ],
        upload: [
          { required: true, message: '请选择托运三证合一', trigger: 'blur' }
        ]
      },
      // 托 三证合一
      img: [],
      img1: [],
      img2: [],
      // img3: [],
      // img4: [],
      imgList: [],
      // 托 非三证合一
      Fimg: [],
      Fimg1: [],
      Fimg2: [],
      Fimg3: [],
      Fimg4: [],
      imgListF: [],
      // 承 三证合一
      cYimg: [],
      cYimg1: [],
      cYimg2: [],
      cYimg3: [],
      imgListcY: [],
      // 承运 非三证合一
      FcYimg: [],
      FcYimg1: [],
      FcYimg2: [],
      FcYimg3: [],
      FcYimg4: [],
      FcYimg5: [],
      imgListFcY: [],
      isAddImg: false,
      submitLoading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      isflg: true,
      // 车队长
      cheDui1: [],
      cheDui2: [],
      cheDui3: [],
      cheDui4: [],
      cheDuiList: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.getChangeData()
    })

    // this.imgfile.append('params', '')
  },
  mounted () {
  },
  methods: {
    loginTo () {
      this.$router.push('/systemManagement/enterprise')
    },
    // 验证手机
    validateMobile (mobile) {
      return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
    },
    getChangeData () {
      this.registerInfo = JSON.parse(localStorage.getItem('registerInfo'))
      if (this.registerInfo != null) {
        this.businessFlg = this.registerInfo.businessFlg
        this.tuoYunFrom.companyName = this.registerInfo.companyName
        this.tuoYunFrom.bsnsLicenseno = this.registerInfo.bsnsLicenseno
        this.tuoYunFrom.transPermitno = this.registerInfo.transPermitno
        this.tuoYunFrom.legalPerson = this.registerInfo.legalPerson
        this.tuoYunFrom.legalPersonId = this.registerInfo.legalPersonId
        this.tuoYunFrom.personidValidity = this.formatter(this.registerInfo.personidValidity, 'yyyy-MM-dd')
        this.tuoYunFrom.contractName = this.registerInfo.contractName
        this.tuoYunFrom.contractPhone = this.registerInfo.contractPhone
        this.tuoYunFrom.bsnsOneness = this.registerInfo.bsnsOneness
        this.tuoYunFrom.transPermitno = this.registerInfo.transPermitno
        if (this.tuoYunFrom.bsnsOneness == '0' && this.businessFlg == '1') { // 托运三证合一
        // 营业执照三证合一
          this.$set(this.img, 0, { status: 'ready', url: this.registerInfo.bsnsLicensepic })
          this.$set(this.imgList, 0, 1)
          // 身份证正面
          this.$set(this.img1, 0, { status: 'ready', url: this.registerInfo.legalPersonpic1 })
          this.$set(this.imgList, 1, 1)
          // 身份证反面
          this.$set(this.img2, 0, { status: 'ready', url: this.registerInfo.legalPersonpic2 })
          this.$set(this.imgList, 2, 1)
        }
        if (this.tuoYunFrom.bsnsOneness == '0' && this.businessFlg == '2') { // 承运三证合一
          // 承运 三证合一营业执照
          this.$set(this.cYimg, 0, { status: 'ready', url: this.registerInfo.bsnsLicensepic })
          this.$set(this.imgListcY, 0, 1)
          // 承运 三证合一道路许可证
          this.$set(this.cYimg1, 0, { status: 'ready', url: this.registerInfo.transPermitpic1 })
          this.$set(this.imgListcY, 1, 1)
          // 承运 三证合一身份证正面
          this.$set(this.cYimg2, 0, { status: 'ready', url: this.registerInfo.legalPersonpic1 })
          this.$set(this.imgListcY, 2, 1)
          // 承运 三证合一身份证返面
          this.$set(this.cYimg3, 0, { status: 'ready', url: this.registerInfo.legalPersonpic2 })
          this.$set(this.imgListcY, 3, 1)
        }

        if (this.tuoYunFrom.bsnsOneness == '1' && this.businessFlg == '1') { // 托运非三证合一
        // 托 非营业执照三证合一
          this.$set(this.Fimg, 0, { status: 'ready', url: this.registerInfo.businessLicensepic })
          this.$set(this.imgListF, 0, 1)
          // 托 非税务登记证
          this.$set(this.Fimg1, 0, { status: 'ready', url: this.registerInfo.taxRegistrapic })
          this.$set(this.imgListF, 1, 1)
          // 托 非组织机构代码
          this.$set(this.Fimg2, 0, { status: 'ready', url: this.registerInfo.taxOrgcodepic })
          this.$set(this.imgListF, 2, 1)
          // 托 非身份证正面
          this.$set(this.Fimg3, 0, { status: 'ready', url: this.registerInfo.legalPersonpic1 })
          this.$set(this.imgListF, 3, 1)
          // 托 非身份证返面
          this.$set(this.Fimg4, 0, { status: 'ready', url: this.registerInfo.legalPersonpic2 })
          this.$set(this.imgListF, 4, 1)
        }
        if (this.tuoYunFrom.bsnsOneness == '1' && this.businessFlg == '2') { // 承运非三证合一
          // 承运 非三证合一营业执照
          this.$set(this.FcYimg, 0, { status: 'ready', url: this.registerInfo.businessLicensepic })
          this.$set(this.imgListFcY, 0, 1)
          // 承运 非三证合一税务登记
          this.$set(this.FcYimg1, 0, { status: 'ready', url: this.registerInfo.taxRegistrapic })
          this.$set(this.imgListFcY, 1, 1)
          // 承运 非三证合一道路许可
          this.$set(this.FcYimg2, 0, { status: 'ready', url: this.registerInfo.transPermitpic1 })
          this.$set(this.imgListFcY, 2, 1)
          // 承运 非三证合一组织机构代码
          this.$set(this.FcYimg3, 0, { status: 'ready', url: this.registerInfo.taxOrgcodepic })
          this.$set(this.imgListFcY, 3, 1)
          // 承运 非三证合一身份证正面
          this.$set(this.FcYimg4, 0, { status: 'ready', url: this.registerInfo.legalPersonpic1 })
          this.$set(this.imgListFcY, 4, 1)
          // 承运 非三证合一身份证返面
          this.$set(this.FcYimg5, 0, { status: 'ready', url: this.registerInfo.legalPersonpic2 })
          this.$set(this.imgListFcY, 5, 1)
        }
        if (this.businessFlg == '3') { // 托运三证合一
          // 身份证正面
          this.$set(this.cheDui1, 0, { status: 'ready', url: this.registerInfo.legalPersonpic1 })
          this.$set(this.cheDuiList, 0, 1)
          // 身份证反面
          this.$set(this.cheDui2, 0, { status: 'ready', url: this.registerInfo.legalPersonpic2 })
          this.$set(this.cheDuiList, 1, 1)
          if (this.registerInfo.bsnsOneness == '0') {
            // 驾驶证
            this.$set(this.cheDui3, 0, { status: 'ready', url: this.registerInfo.transPermitpic1 })
            this.$set(this.cheDuiList, 2, 1)
            this.$set(this.cheDui4, 0, { status: 'ready', url: this.registerInfo.transPermitpic2 })
            this.$set(this.cheDuiList, 3, 1)
          }
        }
      }
    },
    // 营业执照失去焦点调接口获取联系人和联系电话
    getcontractNameOrTel () {
      this.$axios({
        // headers: {
        //   'Content-Type': 'application/json;charset=UTF-8'
        //   // Authorization: 'Bearer ' + store.getUser().access_token
        // },
        method: 'post',
        url: 'crm/registerInfo/CheckcompanyName',
        data: {
          tenantName: this.tuoYunFrom.companyName, // 企业名称
          taxpayerNumber: this.tuoYunFrom.bsnsLicenseno // 营业执照号
        }
      })
        .then(res => {
          // this.smsCode = res.data
          console.log(res, '555')
          if (res.data != null) {
            this.tuoYunFrom.contractName = res.data.contactsName
            this.tuoYunFrom.contractPhone = res.data.contactsMoblie
            this.contractNameDisabled = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.contractNameDisabled = false
          this.tuoYunFrom.contractName = ''
          this.tuoYunFrom.contractPhone = ''
          // this.$message.error(error.message)
        })
    },
    // 获取图片转base64
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    // 托  三证合一图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    // 托  三证合一图片上传
    handleRemoveF (data) {
      this.imgListF[0] = null
    },
    imgPreviewF (data) {
      this.imgListF[0] = data[0]
    },
    handleRemoveF1 (data) {
      this.imgListF[1] = null
    },
    imgPreviewF1 (data) {
      this.imgListF[1] = data[0]
    },
    handleRemoveF2 (data) {
      this.imgListF[2] = null
    },
    imgPreviewF2 (data) {
      this.imgListF[2] = data[0]
    },
    handleRemoveF3 (data) {
      this.imgListF[3] = null
    },
    imgPreviewF3 (data) {
      this.imgListF[3] = data[0]
    },
    handleRemoveF4 (data) {
      this.imgListF[4] = null
    },
    imgPreviewF4 (data) {
      this.imgListF[4] = data[0]
    },
    // 承运 三证合一
    handleRemovecY (data) {
      this.imgListcY[0] = null
    },
    imgPreviewcY (data) {
      this.imgListcY[0] = data[0]
    },
    handleRemovecY1 (data) {
      this.imgListcY[1] = null
    },
    imgPreviewcY1 (data) {
      this.imgListcY[1] = data[0]
    },
    handleRemovecY2 (data) {
      this.imgListcY[2] = null
    },
    imgPreviewcY2 (data) {
      this.imgListcY[2] = data[0]
    },
    handleRemovecY3 (data) {
      this.imgListcY[3] = null
    },
    imgPreviewcY3 (data) {
      this.imgListcY[3] = data[0]
    },
    // 承运 非三证合一
    handleRemovecYF (data) {
      this.imgListFcY[0] = null
    },
    imgPreviewcYF (data) {
      this.imgListFcY[0] = data[0]
    },
    handleRemovecYF1 (data) {
      this.imgListFcY[1] = null
    },
    imgPreviewcYF1 (data) {
      this.imgListFcY[1] = data[0]
    },
    handleRemovecYF2 (data) {
      this.imgListFcY[2] = null
    },
    imgPreviewcYF2 (data) {
      this.imgListFcY[2] = data[0]
    },
    handleRemovecYF3 (data) {
      this.imgListFcY[3] = null
    },
    imgPreviewcYF3 (data) {
      this.imgListFcY[3] = data[0]
    },
    handleRemovecYF4 (data) {
      this.imgListFcY[4] = null
    },
    imgPreviewcYF4 (data) {
      this.imgListFcY[4] = data[0]
    },
    handleRemovecYF5 (data) {
      this.imgListFcY[5] = null
    },
    imgPreviewcYF5 (data) {
      this.imgListFcY[5] = data[0]
    },
    // 车队长
    cheDuiRemove1 (data) {
      this.cheDuiList[0] = null
    },
    cheDuiPreview1 (data) {
      this.cheDuiList[0] = data[0]
    },
    cheDuiRemove2 (data) {
      this.cheDuiList[1] = null
    },
    cheDuiPreview2 (data) {
      this.cheDuiList[1] = data[0]
    },
    cheDuiRemove3 (data) {
      this.cheDuiList[2] = null
    },
    cheDuiPreview3 (data) {
      this.cheDuiList[2] = data[0]
    },
    cheDuiRemove4 (data) {
      this.cheDuiList[3] = null
    },
    cheDuiPreview4 (data) {
      this.cheDuiList[3] = data[0]
    },
    radioChangeJSZ () {
      if (this.tuoYunFrom.bsnsOneness == '1') {
        this.$set(this.tuoYunFrom, 'transPermitno', '')
        this.cheDuiList.splice(2, 2)
        this.cheDui3 = []
        this.cheDui4 = []
      }
      console.log(this.cheDuiList)
    },
    // 单选框的值改变时
    radioChange (val) {
    },
    // 判断给定日期是否合法
    checkDate (dateStr) {
      dateStr = dateStr.replace(/\//g, '-')
      var dateReg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/
      var rValue = dateStr.match(dateReg)
      if (rValue == null) {
        return false
      }
      rValue[1] = parseInt(rValue[1], 10)
      rValue[2] = parseInt(rValue[2] - 1, 10)
      rValue[3] = parseInt(rValue[3], 10)
      var dateObj = new Date(rValue[1], rValue[2], rValue[3])
      if (dateObj.getFullYear() != rValue[1] || dateObj.getMonth() != rValue[2] || dateObj.getDate() != rValue[3]) {
        return false
      }
      return true
    },

    submitClick (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 日期
          if (this.checkDate(this.tuoYunFrom.personidValidity) == false && this.businessFlg != '3') {
            this.$message.error('日期格式不正确')
          } else {
            let imgfile = new FormData()
            if (this.registerInfo.businessFlg == '1' && this.tuoYunFrom.bsnsOneness == '0') { // 托运
              this.tuoYunFrom.id = this.registerInfo.id
              this.tuoYunFrom.userId = this.registerInfo.userId
              this.tuoYunFrom.tenantCode = localStorage.getItem('tenantUnder')
              this.tuoYunFrom.businessFlg = this.registerInfo.businessFlg
              this.tuoYunFrom.transPermitno = ''
              if (this.imgList.length == '3') {
                let arr = []
                for (let i = 0; i < this.imgList.length; i++) {
                  if (this.imgList[i]) {
                    if (this.imgList[i] != 1) {
                      arr.push({ img: this.imgList[i], index: i })
                    }
                  } else {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  }
                }
                // 托运 三证合一
                imgfile.append('bsnsLicensepicFile', this.imgList[0].raw)
                imgfile.append('legalPersonpic1File', this.imgList[1].raw)
                imgfile.append('legalPersonpic2File', this.imgList[2].raw)
                imgfile.append('params', JSON.stringify(this.tuoYunFrom))
                this.addJK(imgfile)
              } else {
                this.$alert('请上传证件信息', '系统提示')
              }
            }
            if (this.registerInfo.businessFlg == '1' && this.tuoYunFrom.bsnsOneness == '1') { // 托运非三证合一
              this.tuoYunFrom.id = this.registerInfo.id
              this.tuoYunFrom.userId = this.registerInfo.userId
              this.tuoYunFrom.tenantCode = localStorage.getItem('tenantUnder')
              this.tuoYunFrom.businessFlg = this.registerInfo.businessFlg
              this.tuoYunFrom.transPermitno = ''
              // 托运非三证合一
              if (this.imgListF.length == '5') {
                let arr = []
                for (let i = 0; i < this.imgListF.length; i++) {
                  if (this.imgListF[i]) {
                    if (this.imgListF[i] != 1) {
                      arr.push({ img: this.imgListF[i], index: i })
                    }
                  } else {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  }
                }
                // 托运 非三证合一
                imgfile.append('businessLicensepicFile', this.imgListF[0].raw)
                imgfile.append('taxRegistrapicFile', this.imgListF[1].raw)
                imgfile.append('taxOrgcodepicFile', this.imgListF[2].raw)
                imgfile.append('legalPersonpic1File', this.imgListF[3].raw)
                imgfile.append('legalPersonpic2File', this.imgListF[4].raw)
                imgfile.append('params', JSON.stringify(this.tuoYunFrom))
                this.addJK(imgfile)
              } else {
                this.$alert('请上传证件信息', '系统提示')
              }
            }
            if (this.registerInfo.businessFlg == '2' && this.tuoYunFrom.bsnsOneness == '0') { // 承运三证合一
              this.tuoYunFrom.id = this.registerInfo.id
              this.tuoYunFrom.userId = this.registerInfo.userId
              this.tuoYunFrom.tenantCode = localStorage.getItem('tenantUnder')
              this.tuoYunFrom.businessFlg = this.registerInfo.businessFlg
              this.tuoYunFrom.transPermitno = this.registerInfo.transPermitno
              if (this.imgListcY.length == '4') {
                let arr = []
                for (let i = 0; i < this.imgListcY.length; i++) {
                  if (this.imgListcY[i]) {
                    if (this.imgListcY[i] != 1) {
                      arr.push({ img: this.imgListcY[i], index: i })
                    }
                  } else {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  }
                }
                // 承运 三证合一
                imgfile.append('bsnsLicensepicFile', this.imgListcY[0].raw)
                imgfile.append('transPermitpic1File', this.imgListcY[1].raw)
                imgfile.append('legalPersonpic1File', this.imgListcY[2].raw)
                imgfile.append('legalPersonpic2File', this.imgListcY[3].raw)
                imgfile.append('params', JSON.stringify(this.tuoYunFrom))
                this.addJK(imgfile)
              } else {
                this.$alert('请上传证件信息', '系统提示')
              }
            }
            if (this.registerInfo.businessFlg == '2' && this.tuoYunFrom.bsnsOneness == '1') { // 承运非三证合一
              this.tuoYunFrom.id = this.registerInfo.id
              this.tuoYunFrom.userId = this.registerInfo.userId
              this.tuoYunFrom.tenantCode = localStorage.getItem('tenantUnder')
              this.tuoYunFrom.businessFlg = this.registerInfo.businessFlg
              this.tuoYunFrom.transPermitno = this.registerInfo.transPermitno
              if (this.imgListFcY.length == '6') {
                let arr = []
                for (let i = 0; i < this.imgListFcY.length; i++) {
                  if (this.imgListFcY[i]) {
                    if (this.imgListFcY[i] != 1) {
                      arr.push({ img: this.imgListFcY[i], index: i })
                    }
                  } else {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  }
                }
                // 承运 非三证合一
                imgfile.append('businessLicensepicFile', this.imgListFcY[0].raw)
                imgfile.append('taxRegistrapicFile', this.imgListFcY[1].raw)
                imgfile.append('transPermitpic1File', this.imgListFcY[2].raw)
                imgfile.append('taxOrgcodepicFile', this.imgListFcY[3].raw)
                imgfile.append('legalPersonpic1File', this.imgListFcY[4].raw)
                imgfile.append('legalPersonpic2File', this.imgListFcY[5].raw)
                imgfile.append('params', JSON.stringify(this.tuoYunFrom))
                this.addJK(imgfile)
              } else {
                this.$alert('请上传证件信息', '系统提示')
              }
            }
            if (this.registerInfo.businessFlg == '3') { // 车队长
              this.tuoYunFrom.id = this.registerInfo.id
              this.tuoYunFrom.userId = this.registerInfo.userId
              this.tuoYunFrom.tenantCode = localStorage.getItem('tenantUnder')
              this.tuoYunFrom.businessFlg = this.registerInfo.businessFlg
              if ((this.cheDuiList.length == '2' && this.tuoYunFrom.bsnsOneness == '1') || (this.cheDuiList.length == '4' && this.tuoYunFrom.bsnsOneness == '0')) {
                let arr = []
                for (let i = 0; i < this.cheDuiList.length; i++) {
                  if (this.cheDuiList[i]) {
                    if (this.cheDuiList[i] != 1) {
                      arr.push({ img: this.cheDuiList[i], index: i })
                    }
                  } else {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  }
                }
                // 托运 三证合一
                imgfile.append('legalPersonpic1File', this.cheDuiList[0].raw)
                imgfile.append('legalPersonpic2File', this.cheDuiList[1].raw)
                if (this.tuoYunFrom.bsnsOneness == '0') {
                  imgfile.append('transPermitpic1File', this.cheDuiList[2].raw)
                  imgfile.append('transPermitpic2File', this.cheDuiList[3].raw)
                }
                imgfile.append('params', JSON.stringify(this.tuoYunFrom))
                this.addJK(imgfile)
              } else {
                this.$alert('请上传证件信息', '系统提示')
              }
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 添加接口
    addJK (data) {
      this.submitLoading = true
      registerInfoUpdate(data).then(res => {
        this.submitLoading = false
        this.$message.success('修改成功')
        this.$router.push('/systemManagement/enterprise')
      }).catch(error => {
        this.submitLoading = false
        this.$message.error(error.message)
      })
    },
    // 时间格式化
    formatter (thistime, fmt) {
      let $this = new Date(thistime)
      let o = {
        'M+': $this.getMonth() + 1,
        'd+': $this.getDate(),
        'h+': $this.getHours(),
        'm+': $this.getMinutes(),
        's+': $this.getSeconds(),
        'q+': Math.floor(($this.getMonth() + 3) / 3),
        'S': $this.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }
  }
}
</script>
<style lang="less" scoped>
/deep/body{
  width: 100%;
  height: 100%;
  position: relative;
  // background-color:#fff ;
}
.registerBox{
  width: 100%;
  height: 100%;
  background-color:#fff ;
  position: relative;
  left: 0;
  top: 0;
  .el-header {
    background-color: #0c46a2;
    line-height: 46px;
    .text{
      float: right;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .body{
    width: 100%;
    height: 100%;
    position: relative;
    background-color:#fff ;
    // border: solid 1px;
    .body-text{
      font-size: 19px;
      text-align: center;
      padding: 30px 0 30px 0;
      // color: #409EFF;
    }
    .fromBox{
      width: 40%;
      margin: auto;
      // border: solid 1px;
    }
    .uploadBox{
      width: 41%;
      margin: auto;
    }
    .box{
      width: 500px;
      display: flex;
      justify-content: space-around;
      flex-wrap:wrap;
      .zujian{
        height: 148px;
      }
      .imgBox{
        display: flex;
        flex-direction: column;
        width: 150px;
        // /deep/.el-upload--picture-card{
        // // width: 180px;
        // // height: 100px;
        // }
        span{
          text-align: center;
        }
      }
      .hidden /deep/.el-upload--picture-card{
        display: none;
      }
      /deep/.el-upload--picture-card {
        // background-image: url(../../../assets/images/upload2.png);
        background-image: url('../../../../assets/images/upload2.png');
        // background-size:180px 100px;
      }
      // /deep/.el-upload-list--picture-card .el-upload-list__item{
      //   // width: 150px;
      //   // height: 100px;
      // }
    }
    .submitBtn{
      width: 480px;
      padding-top: 30px;
      padding-bottom: 3px;
      margin: auto;
    }
  }
}
</style>
